import {BDCPProductDetails, BDCPSupplierInfo} from '../../../../models/product-details.model';
import {Component, Input, OnInit} from '@angular/core';

import {BDCPShareService} from '../../../shared/services/share.service';

@Component({
  selector: 'bdcp-product-prices',
  templateUrl: './product-prices.component.html',
  styleUrls: ['./product-prices.component.scss']
})
export class BDCPProductPricesComponent implements OnInit {

  @Input() public product: BDCPProductDetails;

  public filteredSupplierInfos: BDCPSupplierInfo[];
  public amount = 0;
  public activated: boolean;
  public clicked: boolean;

  readonly MIDDLE_PROGRAM_GROUP_ID = 'Mittelstandsprogramm';

  public isMiddleProgramActive = false;

  public constructor(
    public share: BDCPShareService,
  ) {
  }

  public ngOnInit(): void {
    this.filterSupplierInfos();
    const authGroups = this.share.sharedModel && this.share.sharedModel.authorizationGroups;
    this.isMiddleProgramActive = authGroups && authGroups.some(group => group.toUpperCase() === this.MIDDLE_PROGRAM_GROUP_ID.toUpperCase());
  }

  public getBasePrice(): string {
    if (this.product.brotherPrices?.monthPromotionOfferingBasePrice !== null) {
      return this.product.brotherPrices.monthPromotionOfferingBasePrice;
    }
    if (this.product.brotherPrices.basePrice !== null) {
      return this.product.brotherPrices.basePrice;
    }
    return '-';
  }

  public getCashback(): string {
    const  resultPrice = this.isMiddleProgramActive ?  this.product?.brotherPrices.smbCashback : this.product?.brotherPrices.cashback;
    return resultPrice === null ? '-' : resultPrice;
  }


  public getFcPrice(): string {
    if (this.product.brotherPrices?.fcPromotionOfferingBasePrice !== null) {
      return this.product.brotherPrices.fcPromotionOfferingBasePrice;
    }
    if (this.product.brotherPrices.fcBasePrice !== null) {
      return this.product.brotherPrices.fcBasePrice;
    }
    return '-';
  }

  public getMiddlePrice(): string {
    const  resultPrice = this.isMiddleProgramActive ?  this.product?.brotherPrices?.smbBasePrice : this.product?.brotherPrices?.fcBasePrice;
    return resultPrice === null ? '-' : resultPrice;
  }

  public filterSupplierInfos(): void {
    this.filteredSupplierInfos = !this.product?.itScopePrices
      ? []
      : [...this.product?.itScopePrices?.supplierInfos?.filter(si => Number(si.stock) >= this.amount)];
    this.clicked = true;
  }

  public amountChange(): void {
    if (this.amount === 0) {
      this.clicked = false;
    }
    this.activated = this.amount > 0;
  }

  public _parseInt(input: string): number {
    if (!input) {
      return 0;
    }
    return parseFloat(input);
  }

    onImageError(event: Event): void {
        const target = event.target as HTMLImageElement;
        target.src = 'assets/images/product_img_dummy.png';
    }
}
